export class SpecialHour {
    public Title: string | null = null;

    public StartDate: Date | null = null;

    public EndDate: Date | null = null;

    public IsOpen: boolean = false;

    public StoreSpecialHourTimes: SpecialHourTime[] = [new SpecialHourTime()];
}

export class SpecialHourTime {
    public OpensAt: Date | null = null;

    public ClosesAt: Date | null = null;
}
